<script>
  import { getContext } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let id = null

  const element = getContext('currentElement')
  const subElement = getContext('currentSubElement')
</script>

<div class={`${cssPrefix}control`}>
  <div class={`${cssPrefix}radio`} class:is-disabled={$element.disabled || $subElement.disabled}>
    <label for={id} class:has-error={$element.error}>
      <slot inputclass={`${cssPrefix}radio`} />
      <span class={`${cssPrefix}toggle-shape`} />
      <span>{$subElement.label}</span>
    </label>
  </div>
</div>
